// Verified clinic details only. Do not add unverified phone numbers,
// social links, doctor counts, or patient counts here.
export const CLINIC = {
  name: "Roots Multispeciality Dental Clinic",
  shortName: "Roots",
  established: 2020,
  rating: 5.0,
  ratingCount: 64,
  hours: "9:00 AM – 8:00 PM",
  hoursDays: "Monday – Sunday",
  address: {
    line1: "GS Building",
    line2: "Near Victoriya College",
    line3: "100 Feet Road",
    area: "Sekharipuram",
    city: "Palakkad",
    pincode: "678010",
    state: "Kerala",
    full: "GS Building, Near Victoriya College, 100 Feet Road, Sekharipuram, Palakkad - 678010, Kerala",
  },
  // Leave blank until the clinic provides a verified number — never hard-code a placeholder.
  phone: "",
  email: "",
  mapsEmbedSrc:
    "https://www.google.com/maps?q=Roots+Multispeciality+Dental+Clinic+Sekharipuram+Palakkad&output=embed",
  mapsDirectionsUrl:
    "https://www.google.com/maps/search/?api=1&query=Roots+Multispeciality+Dental+Clinic+Sekharipuram+Palakkad",
};
